module.exports = __webpack_public_path__ + "img/banner3.736cb51b.png";